declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';


import { FieldData, AutoGenBool } from '../../../../../../models/actor/actor';


@Component({
    selector: 'auto-gen-children',
    templateUrl: './autogenchildren.component.html',
    styleUrls: ['./autogenchildren.component.scss']
})

export class AutoGenChildrenComponent implements OnInit {
    @Input() public mode;
    @Input() public Data: AutoGenBool;

    @Input() public field: FieldData;
    ngOnInit(): void {
      //  alert(this.Data.Data.Title + ' Children Count: ' + this.Data.Children.length)
        //alert('from gen child' + this.mode);
    }
}
